import { FunctionComponent, useState, useRef, useEffect } from "react";
import styles from "./AttachmentModal.module.css";
import { IoMdDocument } from "react-icons/io";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import { themeColors } from "../../theme";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import Modal, { Styles } from "react-modal";
import { uploadAttachment } from "../../../Services/contacts";
import StyledCancelButton from "../../Buttons/StyledCancelButton";
import StyledSubmitButton from "../../Buttons/StyledSubmitButton";


/* ------------------------------------------------------------------
   TYPES
-------------------------------------------------------------------*/
type props = {
  open: boolean;
  close: () => void;
  title: string;
  contactDetail: any;
  type: string;
  attachmentsList: any[];
  user: any;
  theme: any;
};

const AttachmentModal: FunctionComponent<props> = ({
  user,
  open,
  close,
  title,
  contactDetail,
  type,
  attachmentsList,
  theme
}) => {
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);

  /* ------------------------------------------------------
     Upload Handler
     Supports both: click-upload & drag-drop upload
 -------------------------------------------------------*/
  const upload = async (data: FileList | null) => {
    if (data) {
      setLoad(true);
      uploadAttachment(
        contactDetail.contactId,
        data[0],
        attachmentsList,
        type,
        data[0]?.name,
        dispatcher,
        (data) => setLoad(data),
        close
      );
    } else {
      console.log("data is not uploaded");
    }
  };


  /* ------------------------------------------------------
      Modal Styling
  -------------------------------------------------------*/
  const modalStyle: Styles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)", // darkens the background
      zIndex: 1300, // higher than MUI AppBar/Table
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      background: theme
        ? themeColors.cardBackgroundColor
        : themeColors.cardBackgroundColorDark,
      color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
      borderRadius: 16,
      padding: isMobile ? "24px 12px" : "40px 32px",
      maxWidth: 380,
      minWidth: 320,
      border: "none",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      inset: "auto",
      margin: "auto",
    },
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  /* ------------------------------------------------------------------
     RENDER
 -------------------------------------------------------------------*/

  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={close}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        style={modalStyle}
        ariaHideApp={false}
      >
        {load && <Loading />}
        <Box
          sx={{
            width: "100%",
            maxWidth: 340,
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <form style={{ width: "100%" }}>
            {/* ---------------------- HEADING ---------------------- */}
            <Box sx={{ mb: 2 }}>
              <h3
                style={{
                  color: theme ? "#272944" : "#fff",
                  fontFamily: "var(--font-family-main)",
                  fontSize: "var(--font-size-large)",
                  marginBottom: 24,
                  textAlign: "center",
                  fontWeight: 700,
                  letterSpacing: 0.5,
                }}
              >
                {title}
              </h3>
            </Box>

            {/* ---------------------- DRAG BOX ---------------------- */}
            <Grid container spacing={2} sx={{ width: "100%" }}>
              <Grid item xs={12}>
                <Box
                  className={styles.dragBox}
                  style={containerStyles}
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    upload(e.dataTransfer.files);
                    setLoad(true);
                  }}
                >
                  <IoMdDocument size={80} color={"#808080"} />
                  <p>Drag And Drop</p>
                </Box>
              </Grid>
            </Grid>

            {/* ---------------------- ACTION BUTTONS ---------------------- */}
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 4,
                  width: "100%",
                }}
              >
                {/* Cancel Button */}
                <Box style={{ marginRight: 8 }}>
                  <StyledCancelButton onClick={close} isMobile={isMobile}>
                    Cancel
                  </StyledCancelButton>
                </Box>
                {/* Upload button */}
                <Box>
                  <input
                    id="file-input"
                    className={styles.select}
                    type="file"
                    accept=".png,.jpg,.jpeg,.pdf,.docs"
                    onChange={(e) => upload(e.target.files)}
                  />
                  <StyledSubmitButton
                    isMobile={isMobile}
                    onClick={() => document.getElementById("file-input")?.click()}
                  >
                    Upload
                  </StyledSubmitButton>
                </Box>
              </Box>
            </Grid>
          </form>
        </Box>
      </Modal >
    </>
  );
};

/* ------------------------------------------------------------------
   REDUX
-------------------------------------------------------------------*/
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(AttachmentModal);
